// extracted by mini-css-extract-plugin
export var errorBanner = "_kj-2";
export var scroller = "_kj-0";
export var thinking = "_kj-1";
export var visuallyHidden = "_kj-3";